import { motion } from 'motion/react'
import { ComponentProps } from 'react'

type IconProps = { reducedMotion?: boolean; duration?: number; delay?: number; forceAnimate?: boolean } & ComponentProps<'svg'>

const variants = {
    initial: { x: 0, y: 0, scale: 1 },
    hover: { x: [0, 100, 0], y: [0, 100, 0], scale: [1, 1.5, 1, 0.5, 1] },
}

const planetVariants = {
    initial: { opacity: 0 },
    hover: { opacity: [0, 0, 1, 1] },
}
const planetTimes = [0, 0.62, 0.63, 1]

const reducedMotionVariants = {
    initial: { x: 0, y: 0, scale: 1 },
    hover: { x: 0, y: 0, scale: 1 },
}

export const DeepinsightSymbolAnimated = ({ reducedMotion, duration = 4, delay = 1, forceAnimate, ...rest }: IconProps) => (
    <svg width="167" height="167" viewBox="0 0 167 167" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M94.6467 142C120.799 142 142 120.799 142 94.6467C142 68.4942 120.799 47.2935 94.6467 47.2935C68.4942 47.2935 47.2935 68.4942 47.2935 94.6467C47.2935 120.799 68.4942 142 94.6467 142Z"
            fill="#FF5500"
        />
        <motion.path
            variants={reducedMotion ? reducedMotionVariants : variants}
            transition={{ duration: duration, repeat: Infinity, ease: 'easeInOut', delay: delay }}
            d="M41.484 57.968C50.5878 57.968 57.968 50.5878 57.968 41.484C57.968 32.3801 50.5878 25 41.484 25C32.3801 25 25 32.3801 25 41.484C25 50.5878 32.3801 57.968 41.484 57.968Z"
            fill="#061139"
            animate={forceAnimate ? 'hover' : undefined}
        />
        <motion.path
            variants={reducedMotion ? reducedMotionVariants : planetVariants}
            transition={{ duration: duration, repeat: Infinity, delay: delay, times: planetTimes }}
            d="M94.6467 142C120.799 142 142 120.799 142 94.6467C142 68.4942 120.799 47.2935 94.6467 47.2935C68.4942 47.2935 47.2935 68.4942 47.2935 94.6467C47.2935 120.799 68.4942 142 94.6467 142Z"
            fill="#FF5500"
            animate={forceAnimate ? 'hover' : undefined}
        />
    </svg>
)
